// companyId -> string | ID da Compania
// skus -> array[string] | Lista com os ids das SKUs
async function retrieveRewards(companyId, skuIds) {
  const token = await login();

  companyId = companyId.toString();
  const items = skuIds.map((sku) => ({
    skuId: `gid://shopify/ProductVariant/${sku}`,
  }));

  const response = await fetch(
    `${baseUrl}/shopify-price-connector/v1/availability-prices/retrieve-rewards`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        companyId,
        items,
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`Erro na API: ${response.status} ${response.statusText}`);
  }

  return await response.json();
}

// companyId -> string | ID da Compania
// skus -> array[Item] | Lista com os items
// Modelo de Item
// {
//   "skuId": "123456789",
//   "quantity": 3,
//   "stockLevelLimit": 999999999
// }
async function retrieveProductInfoByOrganization(companyId, items) {
  const token = await login();

  companyId = companyId.toString();

  const response = await fetch(
    `${baseUrl}/shopify-price-connector/v1/availability-prices/retrieve-by-organization`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        companyId,
        items,
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`Erro na API: ${response.status} ${response.statusText}`);
  }

  return await response.json();
}

// products -> Product[] | lista de produtos da vitrine
// limit -> int | quantidade máxima de produtos da vitrine
function gatherSkuIds(products, limit) {
  const skuIds = [];

  for (let i = 0; i < limit; i++) {
    const skuId = products[i].variants[0].id;
    if (!skuId) {
      continue;
    }

    skuIds.push(skuId);
  }

  return skuIds;
}

function updateRewardValue(skuId, rewardPoints, minQtd) {
  const priceParagraph = document.querySelectorAll(`.product-price-${skuId}`);
  const rewardsContainer = document.querySelectorAll(`.reward-${skuId}`);
  const rewardsSpan = document.querySelectorAll(`.reward-points-${skuId}`);

  if (!rewardsSpan || !priceParagraph || !rewardsContainer) {
    return;
  }

  for (const paragraph of priceParagraph) {
    paragraph.setAttribute("data-rewards", "true");
  }
  for (const container of rewardsContainer) {
    container.classList.add("active");
  }
  for (const span of rewardsSpan) {
    span.textContent = (
      parseInt(rewardPoints)
    ).toLocaleString("pt-BR");
  }
}

function updateShowcaseDOM(requestData) {
  for (const data of requestData) {
    if (!data.rewards || !data.canBuyWithRewards) {
      continue;
    }

    if (!data.minQtd) {
      minQtd = 1;
    }

    updateRewardValue(
      data.shopifySkuId.split("/").pop(),
      data.rewards,
      data.minQtd
    );
  }
}

function updatePdpPrice(items) {
  for (const item of items) {
    const skuId = item.shopifySkuId.split("/").pop();

    if (item.taxes) {
      const taxesParagraph = document.getElementById(`product-taxes-${skuId}`);

      const validTaxNames = ["icms", "icmsZFM", "ipi", "st"];

      const validTaxes = Object.keys(item.taxes)
        .filter((k) => validTaxNames.find((v) => `${v}Percent` === k))
        .map((taxKey) => [taxKey.replace("Percent", ""), item.taxes[taxKey]])
        .filter(([_, value]) => value > 0)
        .map(([key, value]) => {
          let fKey = "";

          switch (key) {
            case "st":
              fKey = "ICMSST";
              break;
            default:
              fKey = key.toUpperCase();
          }

          return `${fKey}: ${value}%`;
        });

      const formatted = validTaxes.join(" | ");

      taxesParagraph.innerHTML = formatted;
    }
    if (item.rewards) {
      const priceParagraph = document.querySelectorAll(
        `.product-price-${skuId}`
      );
      const rewardsContainer = document.querySelectorAll(`.reward-${skuId}`);
      const rewardsSpan = document.querySelectorAll(`.reward-points-${skuId}`);

      if (!rewardsSpan || !priceParagraph || !rewardsContainer) {
        return;
      }

      for (const paragraph of priceParagraph) {
        paragraph.setAttribute("data-rewards", "true");
      }
      for (const container of rewardsContainer) {
        container.classList.add("active");
      }
      for (const span of rewardsSpan) {
        const rewardsValue = Math.round(
          parseInt(item.rewards) / parseInt(item.quantity)
        );
        span.textContent = rewardsValue.toLocaleString("pt-BR");
      }
    }
  }
}

function updateShippingAvailability(items, unitMeasure, measureGender) {
  const deliveryTextContainer = document.querySelector(
    ".custom-delivery-disponibility"
  );
  const deliveryContainer = document.querySelector(
    ".custom-delivery-container"
  );

  for (const item of items) {
    const { billingDays, shippings } = item;
    for (const shipping of shippings) {
      const shippingGroupElement = document.createElement("div");

      const { quantity, additionalDays } = shipping;
      const totalEstimate = additionalDays + billingDays;

      if (additionalDays > 0) {
        shippingGroupElement.innerHTML = `${quantity} ${unitMeasure}${
          quantity === 1
            ? ` será produzid${measureGender}`
            : `s serão produzid${measureGender}s`
        }. <strong>Embarque em até ${totalEstimate} dias.</strong>`;
      } else if (additionalDays === 0) {
        shippingGroupElement.innerHTML = `${quantity} ${unitMeasure}${
          quantity === 1 ? "" : "s"
        } em estoque. <strong>Embarque imediato (${totalEstimate} dias).</strong>`;
      } else {
        shippingGroupElement.innerHTML = `Prazo sob consulta.`;
      }

      deliveryTextContainer.appendChild(shippingGroupElement);
    }

    deliveryContainer.style.opacity = "1";
    deliveryContainer.style.height = "auto";
  }
}
